export class GengiFormFieldsContent {
    gengi: string;
    utistandandiEiningar: string; //óbreytt
    vidskiptiGaerdagsins: string; //óbreytt
    vidbotVidMarkadsverd: string;
    ouppgerdVerdbrefavidskipti: string;  // inital hjá lsr, new frá dw
    comments: string;  // initial skráð  hjá lsr
    markadsverd: string;  // inital skráð hjá lsr, new frá dw
    ouppgerdVerdbrefavidskiptiUpplysingar: [] | null;
}